module.exports = __webpack_public_path__ + "static/media/unterweisung_loesung.9a521d65.jpg";